// src/components/common/TermsModal.tsx
// Modal dos Termos de Uso (issue #6). Dois modos:
//  - 'accept'  : gate obrigatório (Aceitar / Recusar), não fecha por overlay/X.
//  - 'view'    : só leitura (Fechar), acionado pelo item do dropdown pós-aceite.
// O texto vem do banco em markdown e é renderizado com react-markdown, que NÃO
// interpreta HTML bruto por padrão — imune a XSS armazenado no texto.
import React from 'react';
import Markdown from 'react-markdown';
import Modal from './Modal';
import type { TermosVigente } from '@/types/termos';
import './TermsModal.css';

interface TermsModalProps {
  isOpen: boolean;
  theme: 'dark' | 'light';
  mode: 'accept' | 'view';
  loading: boolean;
  submitting: boolean;
  errorMsg: string | null;
  termos: TermosVigente | null;
  onAccept: () => void;
  onRefuse: () => void;
  onCloseView: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  theme,
  mode,
  loading,
  submitting,
  errorMsg,
  termos,
  onAccept,
  onRefuse,
  onCloseView,
}) => {
  const isAccept = mode === 'accept';

  return (
    <Modal
      isOpen={isOpen}
      theme={theme}
      // Modo aceite é bloqueante: só sai por Aceitar/Recusar. Modo leitura fecha.
      closable={!isAccept}
      onClose={onCloseView}
    >
      <div className="terms-modal" data-mode={mode}>
        <h3 className="terms-modal-title">Termos de Uso</h3>
        {termos?.versao && (
          <p className="terms-modal-version">Versão {termos.versao}</p>
        )}

        <div className="terms-modal-body">
          {loading ? (
            <p className="terms-modal-status">Carregando termos…</p>
          ) : termos?.texto ? (
            <div className="terms-modal-markdown">
              <Markdown>{termos.texto}</Markdown>
            </div>
          ) : (
            <p className="terms-modal-status">
              {errorMsg ?? 'Termos de uso indisponíveis no momento.'}
            </p>
          )}
        </div>

        {errorMsg && !loading && termos?.texto && (
          <p className="terms-modal-error" role="alert">{errorMsg}</p>
        )}

        <div className="terms-modal-buttons">
          {isAccept ? (
            <>
              <button
                type="button"
                className="terms-modal-button terms-modal-button-refuse"
                onClick={onRefuse}
                disabled={submitting}
              >
                Recusar
              </button>
              <button
                type="button"
                className="terms-modal-button terms-modal-button-accept"
                onClick={onAccept}
                disabled={submitting || loading || !termos?.texto}
              >
                {submitting ? 'Registrando…' : 'Aceitar'}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="terms-modal-button terms-modal-button-accept"
              onClick={onCloseView}
            >
              Fechar
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TermsModal;
